import Fremont1 from '../../Media/KHI/Freemont.webp'
import Fremont2 from '../../Media/KHI/Freemont.webp'


const Fremontimages =[
Fremont1,Fremont2
]

export default Fremontimages;